module.exports = __webpack_public_path__ + "img/down.a0d4d39d.png";